import axios from 'axios'

export default {
  uploadFileReport (file) {
    /* WTF ?? */
    let formData = new FormData()
    formData.append('file', file)
    formData.append('_method', 'PUT')
    /* WTF ?? */

    return new Promise((resolve, reject) => {
      axios.post('/api/working-time/management/file-report', formData, {
        headers: {
          Authorization: 'Bearer' + localStorage.getItem('access_token')
        }
      }).then(({ data }) => {
        resolve(data)
      }, error => {
        reject(error)
      })
    })
  }
}
